import articleTypes from "astrid-firestore/src/api/articles/constants/articleTypes";

import Form from "../../../forms/components/Form/Form";

export const ebookOptions = [
	{ key: "85", value: "85", text: "8.5 E-bøker til allmennmarkedet", disabled: true },
	{ key: "851", value: "851", text: "8.5.1 Norsk sakprosa, voksne" },
	{ key: "852", value: "852", text: "8.5.2 Norsk skjønnlitteratur, voksne" },
	{ key: "853", value: "853", text: "8.5.3 Oversatt sakprosa, voksne" },
	{ key: "854", value: "854", text: "8.5.4 Oversatt skjønnlitteratur, voksne" },
	{ key: "855", value: "855", text: "8.5.5 Norsk sakprosa, barn og unge" },
	{ key: "856", value: "856", text: "8.5.6 Norsk skjønnlitteratur, barn og unge" },
	{ key: "857", value: "857", text: "8.5.7 Oversatt sakprosa, barn og unge" },
	{ key: "858", value: "858", text: "8.5.8 Oversatt skjønnlitteratur, barn og unge" },
	{ key: "850", value: "850", text: "8.5.0 Diverse" },
	{ key: "89", value: "89", text: "8.9 E-bøker for undervisnings- og profesjonsformål", disabled: true },
	{ key: "891", value: "891", text: "8.9.1 Grunnskolen" },
	{ key: "892", value: "892", text: "8.9.2 Videregående skole" },
	{ key: "893", value: "893", text: "8.9.3 Høyere utdanning" },
	{ key: "894", value: "894", text: "8.9.4 Voksenopplæring" },
	{ key: "895", value: "895", text: "8.9.5 Faglitteratur for profesjonsmarkedet" },
	{ key: "890", value: "890", text: "8.9.0 Diverse" },
];

export const audiobookOptions = [
	{ key: "88", value: "88", text: "8.8 Lydbøker lydfil for allmennmarkedet", disabled: true },
	{ key: "881", value: "881", text: "8.8.1 Norsk sakprosa for voksne" },
	{ key: "882", value: "882", text: "8.8.2 Norsk skjønnlitteratur for voksne" },
	{ key: "883", value: "883", text: "8.8.3 Oversatt sakprosa for voksne" },
	{ key: "884", value: "884", text: "8.8.4 Oversatt skjønnlitteratur for voksne" },
	{ key: "885", value: "885", text: "8.8.5 Norsk sakprosa for barn og ungdom" },
	{ key: "886", value: "886", text: "8.8.6 Norsk skjønnlitteratur for barn og ungdom" },
	{ key: "887", value: "887", text: "8.8.7 Oversatt sakprosa for barn og ungdom" },
	{ key: "888", value: "888", text: "8.8.8 Oversatt skjønnlitteratur for barn og ungdom" },
	{ key: "880", value: "880", text: "8.8.0 Diverse" },
];

export default function ArticleMetaDataBokgruppeSelect({ name, type }) {
	return (
		<Form.Select
			search
			allowEmpty
			options={type === articleTypes.EBOOK ? ebookOptions : audiobookOptions}
			name={name}
		/>
	);
}
